// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-dotted-pattern {
  background-color: #F9FAFB;
  background-image: 
    linear-gradient(to right, rgba(209, 213, 219, 0.2) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(209, 213, 219, 0.2) 1px, transparent 1px);
  background-size: 20px 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/BackgroundPattern.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB;;6EAE2E;EAC3E,0BAA0B;AAC5B","sourcesContent":[".bg-dotted-pattern {\n  background-color: #F9FAFB;\n  background-image: \n    linear-gradient(to right, rgba(209, 213, 219, 0.2) 1px, transparent 1px),\n    linear-gradient(to bottom, rgba(209, 213, 219, 0.2) 1px, transparent 1px);\n  background-size: 20px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
